import React from 'react';
import { AppStatus } from '../api/client';

interface StatusBannerProps {
  status: AppStatus | null;
  onNavigateToSettings?: () => void;
}

const StatusBanner: React.FC<StatusBannerProps> = ({ status, onNavigateToSettings }) => {
  if (!status || status.warnings.length === 0) {
    return null;
  }

  return (
    <div style={{
      background: '#fff3cd',
      borderBottom: '1px solid #ffc107',
      padding: '12px 20px',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <span style={{ fontSize: '18px' }}>⚠️</span>
          <div style={{ flex: 1 }}>
            <strong style={{ color: '#856404', fontSize: '14px' }}>Setup Required</strong>
            <ul style={{ 
              margin: '8px 0 0 0', 
              paddingLeft: '20px',
              color: '#856404',
              fontSize: '13px'
            }}>
              {status.warnings.map((warning, index) => (
                <li key={index} style={{ marginBottom: '4px' }}>{warning}</li>
              ))}
            </ul>
          </div>
          {onNavigateToSettings && (
            <button
              onClick={onNavigateToSettings}
              style={{
                background: '#856404',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: 500,
              }}
            >
              Configure Settings
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusBanner;
